import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const JobTypeApi = createApi({
  reducerPath: "JobTypeApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    // Start JobType API's--------------------------------------
    getAllJobTypeData: builder.query({
      query: () => "get_all_job_types",
      transformResponse: (response) => response?.data || [],
    }),
    addJobType: builder.mutation({
      query: (addJobType) => ({
        url: "add_job_type",
        method: "POST",
        body: addJobType,
      }),
    }),
    editJobType: builder.mutation({
      query: (editJobType) => ({
        url: `update_job_type`,
        method: "PUT",
        body: editJobType,
      }),
    }),
    deleteJobType: builder.mutation({
      query: (id) => ({
        url: `delete_job_type/${id}`,
        method: "DELETE",
      }),
    }),

    // END JobType API's----------------------------------------
  }),
});

export const {
  //jobType api
  useGetAllJobTypeDataQuery,
  useAddJobTypeMutation,
  useEditJobTypeMutation,
  useDeleteJobTypeMutation,
} = JobTypeApi;

export default JobTypeApi;
